import { Conversa, MensagensFiltros } from 'api/Assessor/duvidas';

interface MensagensState {
  filtros: MensagensFiltros;
  conversaAtual: Conversa | null;
}

type MensagensActionType = 'setFiltro' | 'setConversa';

interface MensagensAction {
  type: MensagensActionType;
  value?: any;
}

export const mensagensInitialState: MensagensState = {
  filtros: {
    size: 15,
    page: 1,
  },
  conversaAtual: null,
};

export const mensagensReducer = (
  state: MensagensState,
  action: MensagensAction
): MensagensState => {
  switch (action.type) {
    case 'setFiltro':
      return { ...state, filtros: action.value };
    case 'setConversa':
      return { ...state, conversaAtual: action.value };
    default:
      return state;
  }
};
